<template>
  <tr style="position: relative;    border-bottom: none;" v-if="list">
    <td
      class="d-flex  align-items-center"
      style=" justify-content:space-evenly"
      data-label="没有中文名字"
    >
      <span> {{ keys + 1 }}</span>
      <b-form-checkbox
        name="healthCheck"
        v-model="value.noChineseName"
        :disabled="value.disabled"
      >
      </b-form-checkbox>
    </td>
    <td data-label="姓">
      <b-form-group>
        <b-form-input
          style="background: white"
          aria-readonly="true"
          @input="inputChange($event)"
          :list="gender + '|' + Index + 'list' + keys + '1'"
          autocomplete="off"
          class="input ui-autocomplete-input"
          type="text"
          v-model="value.lastName"
          name="fisrtname"
          :class="errors.has('fisrtname') && 'is-invalid'"
          v-validate="{ ...rules.name, required: !value.noChineseName }"
          :placeholder="$lang('lang-zh-hant')"
          :disabled="value.disabled || value.noChineseName"
        />
        <b-form-invalid-feedback :state="errors.has('fisrtname')">
          {{ errors.first("fisrtname") }}
        </b-form-invalid-feedback>
      </b-form-group>

      <datalist :id="gender + '|' + Index + 'list' + keys + '1'">
        <option
          v-for="(item, index) in gender == 2
            ? Mlist
            : gender == 3
            ? Flist
            : list"
          :key="index"
        >
          {{
            (item.lastName ? item.lastName : item.lastNameOther) +
              (item.firstName ? item.firstName : item.firstNameOther) +
              "|" +
              item.idNumber
          }}
        </option>
      </datalist>
      <b-form-group>
        <b-form-input
          @input="inputChange($event)"
          :list="gender + '|' + Index + 'list' + keys + '2'"
          style="background: white"
          autocomplete="off"
          class="input ui-autocomplete-input"
          type="text"
          v-model="value.firstNameOther"
          name="fisrtnameo"
          :class="errors.has('fisrtnameo') && 'is-invalid'"
          v-validate="{ ...rules.name, required: true }"
          :placeholder="$lang('lang-other')"
          :disabled="value.disabled"
        />
        <b-form-invalid-feedback :state="errors.has('fisrtnameo')">
          {{ errors.first("fisrtnameo") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <datalist :id="gender + '|' + Index + 'list' + keys + '2'">
        <option
          v-for="(item, index) in gender == 2
            ? Mlist
            : gender == 3
            ? Flist
            : list"
          :key="index"
        >
          {{
            (item.lastNameOther ? item.lastNameOther : item.lastName) +
              (item.firstNameOther ? item.firstNameOther : item.firstName) +
              "|" +
              item.idNumber
          }}
        </option>
      </datalist>
    </td>
    <td data-label="名字">
      <b-form-group>
        <b-form-input
          @input="inputChange($event)"
          style="background: white "
          autocomplete="off"
          :list="gender + '|' + Index + 'list' + keys + '3'"
          class="input ui-autocomplete-input"
          type="text"
          v-model="value.firstName"
          name="lastname"
          :class="errors.has('lastname') && 'is-invalid'"
          v-validate="{ ...rules.name, required: !value.noChineseName }"
          :placeholder="$lang('lang-zh-hant')"
          :disabled="value.disabled || value.noChineseName"
        />
        <b-form-invalid-feedback :state="errors.has('lastname')">
          {{ errors.first("lastname") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <datalist :id="gender + '|' + Index + 'list' + keys + '3'">
        <option
          v-for="(item, index) in gender == 2
            ? Mlist
            : gender == 3
            ? Flist
            : list"
          :key="index + 'lastNamelist'"
        >
          {{
            (item.lastName ? item.lastName : item.lastNameOther) +
              (item.firstName ? item.firstName : item.firstNameOther) +
              "|" +
              item.idNumber
          }}
        </option>
      </datalist>
      <b-form-group>
        <b-form-input
          @input="inputChange($event)"
          style="background: white "
          :list="gender + '|' + Index + 'list' + keys + '4'"
          autocomplete="off"
          class="input ui-autocomplete-input"
          type="text"
          v-model="value.lastNameOther"
          name="lasttnameo"
          :class="errors.has('lasttnameo') && 'is-invalid'"
          v-validate="{ ...rules.name, required: true }"
          :placeholder="$lang('lang-other')"
          :disabled="value.disabled"
        />
        <b-form-invalid-feedback :state="errors.has('lasttnameo')">
          {{ errors.first("lasttnameo") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <datalist :id="gender + '|' + Index + 'list' + keys + '4'">
        <option
          v-for="(item, index) in gender == 2
            ? Mlist
            : gender == 3
            ? Flist
            : list"
          :key="index"
        >
          {{
            (item.lastNameOther ? item.lastNameOther : item.lastName) +
              (item.firstNameOther ? item.firstNameOther : item.firstName) +
              "|" +
              item.idNumber
          }}
        </option>
      </datalist>
    </td>
    <!-- <td data-label="外文姓">
    
    </td>
    <td data-label="外文名字">
  
    </td> -->
    <td data-label="出生日期">
      <b-form-group>
        <DatePicker
          type="date"
          :options="options"
          v-model="value.birthday"
          name="bornAt"
          size="large"
          :start-date="new Date(2004, 3, 15)"
          :class="errors.has('bornAt') && 'is-invalid'"
          v-validate="{ required: true }"
          format="yyyy/MM/dd"
          :disabled="value.disabled"
        ></DatePicker>
        <b-form-invalid-feedback :state="errors.has('bornAt')">
          {{ errors.first("bornAt") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </td>
    <td data-label="性別">
      <b-form-group>
        <b-form-select
          class="py-0 input ui-autocomplete-input"
          v-model="value.gender"
          name="sex"
          :class="errors.has('sex') && 'is-invalid'"
          v-validate="{ ...rules.sex, required: true }"
          :placeholder="$lang('')"
          :disabled="value.disabled"
        >
          <option value="M">{{ $lang("FIELD_MALE") }}</option>
          <option value="F">{{ $lang("FIELD_FEMALE") }}</option>
        </b-form-select>
        <b-form-invalid-feedback :state="errors.has('sex')">
          {{ errors.first("sex") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </td>
    <td>
      <b-form-group>
        <b-input-group>
          <b-form-select
            v-model="value.idType"
            name="idType"
            v-validate="{ required: true }"
            class="input py-0 ui-autocomplete-input"
            :class="errors.has('idType') && 'is-invalid'"
            :disabled="value.disabled"
          >
            <option :value="1">{{ $lang("TEXT_ID_TYPE_MACAO") }}</option>
            <option :value="2">{{ $lang("TEXT_ID_TYPE_PASSPORT") }}</option>
            <option :value="3">{{ $lang("TEXT_ID_TYPE_OTHER") }}</option>
          </b-form-select>
          <b-form-invalid-feedback :state="errors.has('idType')">{{
            errors.first("idType")
          }}</b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
    </td>
    <td data-label="證件號碼:">
      <b-form-group>
        <b-form-input
          autocomplete="off"
          style="background: white "
          @input="inputChange($event)"
          :list="gender + '|' + Index + 'list' + keys + '5'"
          type="text"
          v-model="value.idNumber"
          name="idNumber"
          :class="errors.has('idNumber') && 'is-invalid'"
          v-validate="{
            ...rules.idNumber,
            idNumber: value.idType == 1,
            required: true,
          }"
          :placeholder="$lang('')"
          :disabled="value.disabled"
        />
        <b-form-invalid-feedback :state="errors.has('idNumber')">
          {{ errors.first("idNumber") }}
        </b-form-invalid-feedback>
      </b-form-group>
      <datalist :id="gender + '|' + Index + 'list' + keys + '5'">
        <option
          v-for="(item, index) in gender == 2
            ? Mlist
            : gender == 3
            ? Flist
            : list"
          :key="index"
        >
          {{
            (item.lastName ? item.lastName : item.lastNameOther) +
              (item.firstName ? item.firstName : item.firstNameOther) +
              "|" +
              item.idNumber
          }}
        </option>
      </datalist>
    </td>
    <td data-label="近照">
      <!-- <span class="upload-btn" data-name="game[198][gamer][1][pic]"
        ></span
      ></span> -->

      <InputFile
        class="pic"
        :height="60"
        accept=".jpg, .png, .gif, .jpeg,"
        v-model="value.pic"
        :word="$lang('上传')"
        :disabled="true"
      />
      <b-form-group>
        <b-form-input
          v-show="false"
          class="input ui-autocomplete-input"
          type="text"
          v-model="value.pic"
          name="pic"
          :class="errors.has('pic') && 'is-invalid'"
          v-validate="{ required: true }"
          :placeholder="$lang('')"
          :disabled="value.disabled"
        />
        <b-form-invalid-feedback class="m-0" :state="errors.has('pic')">
          {{ errors.first("pic") }}
        </b-form-invalid-feedback>
      </b-form-group>
    </td>
  </tr>
  <!-- <tr><slot v-if="!disabled" name="remove"></slot></tr> -->
</template>

<script>
import InputFile from "./inputFile.vue";
export default {
  components: {
    InputFile,
  },
  props: {
    Index: {},
    gender: {},
    keys: {},
    sportId: {},
    inputlist: {},
    index: String,
    value: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
    },
    requiredType: {
      type: Boolean,
    },
  },
  data() {
    return {
      noChineseName: false,
      options: {
        disabledDate(date) {
          return date && date.valueOf() > new Date("2004-04-15").valueOf();
        },
      },
      i: [],
      list: [],
      Mlist: [],
      Flist: [],
      lastNamelist: [],
    };
  },

  mounted() {
    Object.keys(this.inputlist).forEach((element) => {
      this.$set(
        this.list,
        element - 1,
        JSON.parse(JSON.stringify(this.inputlist[element]))
      );
    });
    this.list.forEach((item) => {
      // console.log(item);
      if (item.gender == "M") {
        this.Mlist.push(item);
      }
      if (item.gender == "F") {
        this.Flist.push(item);
      }
    });

    // console.log(this.Mlist,this.Flist,this.gender);
  },
  computed: {},
  watch: {
    value: {
      handler(n, o) {
        if (this.value.noChineseName) {
          this.$nextTick(()=>{
            this.value.lastName = "";
          this.value.firstName = "";
          })
        }
      },
      deep: true,
    },
  },
  methods: {
    reset() {
      this.$emit("reset", "resetnovalue", this.keys, this.Index);
    },
    inputChange(e) {
      // var val = e.target;
      //  console.log(e,this.keys);
      // console.log(this.Index, 123);
      this.$emit(
        "updateValue",
        e.split("|")[1],
        this.keys,
        this.Index,
        this.value.noChineseName
      );

      // Object.keys(this.inputlist).forEach((item) => {
      //   // console.log(this.inputlist[item]);
      // });
      // Object.keys(this.inputlist).forEach((element) => {
      //   this.$set(this.firstNamelist, element - 1, this.inputlist[element]);
      // });
      // console.log(this.firstNamelist);
    },
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$validator.validate().then((result) => {
          // console.log(result);
          resolve(result);
        });
      });
    },
    validateErrors(field, msg) {
      this.errors.add({
        field,
        msg,
      });
    },
  },
};
</script>
<style lang="scss">
td {
  // padding: 2em 0.625em 0.625em 0.625em !important;
}
.form-control:disabled {
  background: #e9ecef !important;
}
.form-control:not([disabled]) {
  background: #fff !important;
}
.pic img {
  margin: 0;
}
</style>
